import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import React, { useEffect } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { Pie } from 'react-chartjs-2';
import { HiClipboardDocumentCheck } from "react-icons/hi2";
import { IoDocument, IoDocumentLock } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { dashboardGet } from '../../Redux/Action/Dashboard';
import { fileBaseUrl, formatDate, generateRandomColors, getUserDetail, pieOptions, tenderDate } from '../../Utils/Helper';
import Loader from '../../Utils/Loader';
import './Dashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const Dashboard = () => {
  const dispatch = useDispatch();

  const { loading, dashGetData } = useSelector((state) => state.getDashboard)

  useEffect(() => {
    dispatch(dashboardGet())
  }, [])

  const preparePieChartData = () => {
    if (!dashGetData?.data?.departmentTenderChart) return null;

    const departments = dashGetData?.data?.departmentTenderChart?.map((d) => {
      return d?.department?.name
    });
    const counts = dashGetData?.data?.departmentTenderChart?.map((d) => {
      return d?.count
    });
    const backgroundColors = generateRandomColors(departments.length);

    return {
      labels: departments,
      datasets: [
        {
          data: counts,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors?.map(color => color.replace('0.2', '1')),
          borderWidth: 1,
        },
      ],
    };
  };

  return (
    <div>
      {
        loading ? <Loader /> :
          <div className='dashboard_main'>
            <Row style={{ padding: "0 15px", gap: "15px 0" }}>
              <Col md={12}>
                <h1>Dashboard</h1>
              </Col>

              <Col md={4} sm={6} xs={6}>
                <div className='dashboard_boxes'>
                  <IoDocument />
                  <h6>Total Tenders</h6>
                  <h5>{dashGetData?.data?.activeTenderCount}</h5>
                </div>
              </Col>
              <Col md={4} sm={6} xs={6}>
                <div className='dashboard_boxes depart_box'>
                  <HiClipboardDocumentCheck />
                  <h6>Tender Wins</h6>
                  <h5>{dashGetData?.data?.winCount}</h5>
                </div>
              </Col>
              <Col md={4} sm={6} xs={6}>
                <div className='dashboard_boxes total_user'>
                  <IoDocumentLock />
                  <h6>Tender Lose</h6>
                  <h5>{dashGetData?.data?.lossCount}</h5>
                </div>
              </Col>
            </Row>

            <Row style={{ padding: "0 15px" }}>
              <Col md={12}>
                <div className='application_table recent_table'>
                  <div className='heading'> <h6>Recent Uploads</h6> </div>
                  <div className='table_scroll'>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Tender No.</th>
                          <th>Company</th>
                          <th>Advertise Date</th>
                          <th>Due Date</th>
                          <th>Attachment</th>
                        </tr>
                      </thead>
                      {
                        dashGetData?.data?.latestTender?.length > 0 &&
                        <tbody>
                          {
                            dashGetData?.data?.latestTender?.map((s, i) => {
                              return (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{s.tenderNo}</td>
                                  <td>{s.company}</td>
                                  <td>{formatDate(s?.advertiseDate)}</td>
                                  <td className={tenderDate(s.closingDate)}>{formatDate(s.closingDate)}</td>
                                  <td>
                                    {!s.document ? (
                                      <button
                                        className='download_doc_btn'
                                        style={{
                                          opacity: 0.6,
                                          cursor: 'not-allowed',
                                        }}
                                        title="No Attachment Available"
                                        disabled
                                      >
                                        Download
                                      </button>
                                    ) :
                                      <Link to={`${fileBaseUrl}/${s.document}`} target="_blank" className='download_doc_btn'>
                                        Download
                                      </Link>
                                    }
                                  </td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      }
                    </Table>
                    {dashGetData?.data?.latestTender?.length === 0 && <p className='text-center py-3' style={{ fontWeight: "600" }}>No Data Found</p>}
                  </div>
                </div>
              </Col>

              {
                getUserDetail()?.role === 'super-admin' &&
                <Col md={12}>
                  <div className='dashboard_right_box'>
                    <h3> Departmental Tenders </h3>

                    {
                      dashGetData?.data?.departmentTenderChart?.length > 0 ?
                        <div style={{ height: '400px' }}>
                          <Pie data={preparePieChartData()} options={pieOptions} />
                        </div> : <p className='text-center py-3' style={{ fontWeight: "600" }}>No Data Found</p>
                    }
                  </div>
                </Col>
              }
            </Row>
          </div>
      }
    </div>
  )
}
export default Dashboard